module.exports = __webpack_public_path__ + "img/ts_2005.058db0bf.jpg";